import { render, staticRenderFns } from "./affairStock.vue?vue&type=template&id=c4fb43c0"
import script from "./affairStock.vue?vue&type=script&lang=js"
export * from "./affairStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4fb43c0')) {
      api.createRecord('c4fb43c0', component.options)
    } else {
      api.reload('c4fb43c0', component.options)
    }
    module.hot.accept("./affairStock.vue?vue&type=template&id=c4fb43c0", function () {
      api.rerender('c4fb43c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/stockPage/affairStock.vue"
export default component.exports